module.exports = __webpack_public_path__ + "static/img/11_green.b352ab77.jpg";